/* Naar Halı: Kasım bölümleri (21 Eki 2026)
   1) Geri sayım (hero): gerçek tarihe göre; başlangıçtan önce "başlangıca kalan", başlangıç ile bitiş arasında
      "bitişe kalan" süreyi gösterir; bitişten sonra kutu kendiliğinden kaybolur. Sahte/döngüsel sayaç yoktur.
   2) Kasım takvimi: gerçek tarihlere göre "Bugün / Sıradaki / Tamamlandı" işaretler.
   3) Kasım Seçkisi: yatay kaydırma okları ve ilerleme çizgisi.
   4) Bölümler ekrana girerken yumuşakça belirir; ekranda olmayan hero animasyonları duraklar.
   Her şey idempotenttir (aynı eleman iki kez kurulmaz). */
(function () {
  'use strict';

  function iki(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------- 1) Geri sayım ---------- */
  function sayaclariKur() {
    document.querySelectorAll('[data-nkh-sayac]').forEach(function (kutu) {
      if (kutu.dataset.nkhHazir) return;
      kutu.dataset.nkhHazir = '1';
      var bas = Date.parse(kutu.dataset.baslangic);
      var bit = Date.parse(kutu.dataset.bitis);
      if (isNaN(bas) || isNaN(bit)) { kutu.hidden = true; return; }
      var etiket = kutu.querySelector('[data-nkh-etiket]');
      var hucre = {
        g: kutu.querySelector('[data-b="g"]'),
        s: kutu.querySelector('[data-b="s"]'),
        d: kutu.querySelector('[data-b="d"]'),
        n: kutu.querySelector('[data-b="n"]')
      };
      var onceki = {};
      var sonEtiket = '';

      function yaz(anahtar, deger) {
        var metin = iki(deger);
        if (onceki[anahtar] === metin) return;
        var ilk = onceki[anahtar] === undefined;
        onceki[anahtar] = metin;
        var el = hucre[anahtar];
        if (!el) return;
        el.textContent = metin;
        if (ilk) return;
        el.classList.remove('nkh__rakam--cevir');
        void el.offsetWidth; // animasyonu yeniden başlat
        el.classList.add('nkh__rakam--cevir');
      }

      function tikla() {
        var simdi = Date.now();
        var hedef, yazi;
        if (simdi < bas) { hedef = bas; yazi = kutu.dataset.once; }
        else if (simdi < bit) { hedef = bit; yazi = kutu.dataset.icinde; }
        else { kutu.hidden = true; return false; }
        if (etiket && yazi !== sonEtiket) { etiket.textContent = yazi; sonEtiket = yazi; }
        var kalan = Math.max(0, Math.floor((hedef - simdi) / 1000));
        yaz('g', Math.floor(kalan / 86400));
        yaz('s', Math.floor((kalan % 86400) / 3600));
        yaz('d', Math.floor((kalan % 3600) / 60));
        yaz('n', kalan % 60);
        return true;
      }

      if (!tikla()) return;
      var zamanlayici = setInterval(function () {
        if (!tikla()) clearInterval(zamanlayici);
      }, 1000);
    });
  }

  /* ---------- 2) Kasım takvimi ---------- */
  function takvimiKur() {
    document.querySelectorAll('[data-ntk]').forEach(function (kok) {
      if (kok.dataset.nkhHazir) return;
      kok.dataset.nkhHazir = '1';
      var kartlar = Array.prototype.slice.call(kok.querySelectorAll('[data-bas]'));

      function guncelle() {
        var simdi = Date.now();
        var siradaki = null;
        var sonBitis = 0;
        kartlar.forEach(function (k) {
          var bas = Date.parse(k.dataset.bas);
          var bit = Date.parse(k.dataset.bit);
          if (isNaN(bas) || isNaN(bit)) return;
          sonBitis = Math.max(sonBitis, bit);
          k.classList.remove('ntk__kart--aktif', 'ntk__kart--siradaki', 'ntk__kart--gecmis');
          var durum = k.querySelector('[data-durum]');
          var yazi = '';
          var oran = 0; // ip: dönemin gerçek ilerlemesi (başlamadıysa 0, bittiyse 1)
          if (simdi >= bas && simdi <= bit) { k.classList.add('ntk__kart--aktif'); yazi = 'Bugün'; oran = (simdi - bas) / Math.max(bit - bas, 1); }
          else if (simdi > bit) { k.classList.add('ntk__kart--gecmis'); yazi = 'Tamamlandı'; oran = 1; }
          else if (!siradaki) { siradaki = k; k.classList.add('ntk__kart--siradaki'); yazi = 'Sıradaki'; }
          k.style.setProperty('--ntk-oran', oran.toFixed(3));
          if (durum) durum.textContent = yazi;
        });
        // Bütün dönemler bittiyse bölüm kendiliğinden gizlenir
        kok.hidden = sonBitis > 0 && simdi > sonBitis;
      }
      guncelle();
      setInterval(guncelle, 60000);
    });
  }

  /* ---------- 3) Kasım Seçkisi kaydırıcısı ---------- */
  function seckiyiKur() {
    document.querySelectorAll('[data-nks]').forEach(function (kok) {
      if (kok.dataset.nkhHazir) return;
      kok.dataset.nkhHazir = '1';
      var sira = kok.querySelector('[data-nks-sira]');
      var cizgi = kok.querySelector('[data-nks-cizgi]');
      var geri = kok.querySelector('[data-nks-geri]');
      var ileri = kok.querySelector('[data-nks-ileri]');
      if (!sira) return;
      var bekliyor = false;
      var sablon = kok.querySelector('template[data-nks-ertele]');

      // Ertelenen kartları ekle (seçkiye yaklaşınca, kaydırılınca ya da ok tıklanınca)
      function ertelenenleriAc() {
        if (!sablon || sablon.dataset.acildi) return;
        sablon.dataset.acildi = '1';
        sira.appendChild(sablon.content.cloneNode(true));
        gozlemleriKur();
        guncelle();
      }
      if (sablon) {
        if ('IntersectionObserver' in window) {
          var yakin = new IntersectionObserver(function (k) {
            if (k.some(function (x) { return x.isIntersecting; })) { ertelenenleriAc(); yakin.disconnect(); }
          }, { rootMargin: '300px 0px' });
          yakin.observe(kok);
        } else { ertelenenleriAc(); }
        // 23 Eki 2026: kartlar artık kaydırma/dokunma sırasında eklenmez (hareketin ortasında içerik eklemek
        // kaydırmayı kesiyordu); sayfa yüklendikten sonra boşta eklenir.
        var bosta = function () { ertelenenleriAc(); };
        var zamanla = function () { if ('requestIdleCallback' in window) requestIdleCallback(bosta, { timeout: 3000 }); else setTimeout(bosta, 1500); };
        if (document.readyState === 'complete') zamanla(); else window.addEventListener('load', zamanla, { once: true });
      }

      function guncelle() {
        bekliyor = false;
        var tasma = sira.scrollWidth - sira.clientWidth;
        var oran = tasma > 0 ? sira.scrollLeft / tasma : 0;
        if (cizgi) {
          cizgi.style.setProperty('--nks-pay', (sira.clientWidth / Math.max(sira.scrollWidth, 1)).toFixed(3));
          cizgi.style.setProperty('--nks-konum', oran.toFixed(3));
        }
        if (geri) geri.disabled = sira.scrollLeft <= 2;
        if (ileri) ileri.disabled = sira.scrollLeft >= tasma - 2;
        kok.classList.toggle('nks--tasmiyor', tasma <= 2);
      }
      function kaydir(yon) {
        ertelenenleriAc();
        var kart = sira.querySelector('.nks__oge');
        var adim = kart ? kart.getBoundingClientRect().width + 14 : sira.clientWidth * 0.8;
        sira.scrollBy({ left: yon * adim * (window.innerWidth > 989 ? 2 : 1), behavior: 'smooth' });
      }
      sira.addEventListener('scroll', function () {
        if (!bekliyor) { bekliyor = true; requestAnimationFrame(guncelle); }
      }, { passive: true });

      // Fare ile sürükleyerek kaydırma (dokunmatikte tarayıcının kendi kaydırması çalışır)
      var surukle = null;
      sira.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        surukle = { x: e.clientX, sol: sira.scrollLeft, tasindi: false, id: e.pointerId };
      });
      sira.addEventListener('pointermove', function (e) {
        if (!surukle || e.pointerId !== surukle.id) return;
        var dx = e.clientX - surukle.x;
        if (!surukle.tasindi && Math.abs(dx) < 6) return;
        if (!surukle.tasindi) {
          surukle.tasindi = true;
          sira.classList.add('nks__sira--surukle');
          try { sira.setPointerCapture(e.pointerId); } catch (x) {}
        }
        sira.scrollLeft = surukle.sol - dx;
      });
      function suruklemeBitti(e) {
        if (!surukle || (e && e.pointerId !== surukle.id)) return;
        var tasindi = surukle.tasindi;
        surukle = null;
        if (tasindi) {
          sira.classList.remove('nks__sira--surukle'); // yapışma geri gelir, en yakın karta oturur
          suruklendi = true;
          setTimeout(function () { suruklendi = false; }, 0);
        }
      }
      var suruklendi = false;
      sira.addEventListener('pointerup', suruklemeBitti);
      sira.addEventListener('pointercancel', suruklemeBitti);
      sira.addEventListener('lostpointercapture', suruklemeBitti);
      // Sürükleme sonunda bırakılan karta tıklanmış sayılmasın (yanlışlıkla ürün sayfası açılmasın)
      sira.addEventListener('click', function (e) { if (suruklendi) { e.preventDefault(); e.stopPropagation(); } }, true);
      sira.addEventListener('dragstart', function (e) { e.preventDefault(); });
      window.addEventListener('resize', guncelle);
      if (geri) geri.addEventListener('click', function () { kaydir(-1); });
      if (ileri) ileri.addEventListener('click', function () { kaydir(1); });
      guncelle();
    });
  }

  /* ---------- 4) Belirme efekti + duraklatma ---------- */
  function gozlemleriKur() {
    var belirecekler = document.querySelectorAll('[data-nkh-goster]:not([data-nkh-izleniyor])');
    belirecekler.forEach(function (el) { el.setAttribute('data-nkh-izleniyor', '1'); });
    if (!('IntersectionObserver' in window)) {
      belirecekler.forEach(function (el) { el.classList.add('nkh-gorundu'); });
    } else {
      var g = new IntersectionObserver(function (kayitlar) {
        kayitlar.forEach(function (k) {
          if (!k.isIntersecting) return;
          var el = k.target;
          // Aynı grubun öğeleri sırayla belirir
          var sirasi = Number(el.getAttribute('data-nkh-sira') || 0);
          setTimeout(function () { el.classList.add('nkh-gorundu'); }, Math.min(sirasi, 8) * 90);
          g.unobserve(el);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      belirecekler.forEach(function (el) { g.observe(el); });
    }

    if (!('IntersectionObserver' in window)) return;
    var d = new IntersectionObserver(function (kayitlar) {
      kayitlar.forEach(function (k) { k.target.classList.toggle('nkh--dur', !k.isIntersecting); });
    }, { threshold: 0.01 });
    document.querySelectorAll('[data-nkh]').forEach(function (el) { d.observe(el); });
  }

  function baslat() { sayaclariKur(); takvimiKur(); seckiyiKur(); gozlemleriKur(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baslat);
  else baslat();
  // Tema editörü bölümü yeniden çizdiğinde tekrar kur
  document.addEventListener('shopify:section:load', baslat);
})();
